import i18next from "i18next"

export const ACTIVATION_CODE_SUBJECT = i18next.t("activation_code", { ns: "contact" })
export const MIGRATION_SUBJECT = i18next.t("migration", { ns: "contact" })
export const ADD_BIKE_SUBJECT = i18next.t("add_bike", { ns: "contact" })
export const BIKE_DESCRIPTION_SUBJECT = i18next.t("bike_description_error", { ns: "contact" })
export const UPLOAD_ERROR_SUBJECT = i18next.t("upload_error", { ns: "contact" })
export const PASSPORT_CODE_SUBJECT = i18next.t("passport_code", { ns: "contact" })
export const ADDRESS_ERROR_SUBJECT = i18next.t("address_error", { ns: "contact" })
export const CONSENT_SUBJECT = i18next.t("consent", { ns: "contact" })
export const OTHER_SUBJECT = i18next.t("other", { ns: "contact" })


export const subjectCollection: Array<string> = [ 
    ACTIVATION_CODE_SUBJECT, 
    MIGRATION_SUBJECT,
    ADD_BIKE_SUBJECT,
    BIKE_DESCRIPTION_SUBJECT, 
    UPLOAD_ERROR_SUBJECT,
    PASSPORT_CODE_SUBJECT,
    ADDRESS_ERROR_SUBJECT,
    CONSENT_SUBJECT,
    OTHER_SUBJECT
]

export const subjectCollectionForSelect = subjectCollection.map((subject) => ({
	label: subject,
	value: subject,
}))